export { TranslationModule } from './translation-module';
export { TranslateByObjectTypePipe } from './translate-by-object-type/translate-by-object-type.pipe';
export { TranslateByObjectTypeService } from './translate-by-object-type/translate-by-object-type.service';
export { TranslateForCrmObjectPipe } from './translate-for-crm-object/translate-for-crm-object.pipe';
export { TranslateForCrmObjectService } from './translate-for-crm-object/translate-for-crm-object.service';
